'use client'

import React, { useState } from 'react'

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism'

interface CodeBlockProps {
  inline?: boolean
  className?: string
  children?: React.ReactNode
}

// Copy to clipboard function
const copyToClipboard = (code: string) => {
  return navigator.clipboard.writeText(code)
}

export const CodeBlock = ({
  inline = false,
  className,
  children,
  ...props
}: CodeBlockProps) => {
  const [copied, setCopied] = useState(false)
  const match = /language-(\w+)/.exec(className || '')
  const codeContent = String(children).replace(/\n$/, '')

  const handleCopy = () => {
    copyToClipboard(codeContent)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 200)
      })
      .catch((err) => {
        console.error('Failed to copy code', err)
      })
  }

  return !inline && match ? (
    <div className="relative pt-4">
      {/* Syntax highlighter for code block */}
      <SyntaxHighlighter
        style={dracula}
        PreTag="div"
        language={match[1]}
        {...props}
      >
        {codeContent}
      </SyntaxHighlighter>

      {/* Copy Button */}
      <button
        onClick={handleCopy}
        className={`absolute right-2 top-8 rounded-md px-3 py-1 text-xs font-medium transition-colors duration-300 ${
          copied ? 'bg-base-light/80' : 'bg-base-light hover:bg-base-light/80'
        } text-base-dark`}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </div>
  ) : (
    <code className={className} {...props}>
      {children}
    </code>
  )
}
